import { Injectable } from '@angular/core';

import { AUTH_STRINGS } from 'src/app/shared/constants/app-strings.constants';
import { User } from 'src/app/shared/models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserRoleService {
  /**
   * Public API: can be called anywhere.
   * Returns the role string (e.g. "ADMIN", "Admin", etc) or empty string if not present.
   */
  getUserRole(): string {
    const user = this.getUserFromSessionStorage();
    return (user?.ROLE ?? '').toString();
  }

  private getUserFromSessionStorage(): User | null {
    try {
      const userTokenRaw = sessionStorage.getItem(AUTH_STRINGS.usertoken);
      return userTokenRaw ? (JSON.parse(userTokenRaw) as User) : null;
    } catch {
      return null;
    }
  }
}


